/**
 * BMK Service Configuration
 * Centralized configuration for all API endpoints used in the Build My Kubota application
 */

// API Base URLs
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://change.apps.kubotausa.com/BMK_LP/api' || 'https://apps.kubotausa.com/BMK_LP/api' || 'https://localhost:44390';
const WP_API_BASE_URL = process.env.REACT_APP_WP_API_BASE_URL || 'https://bmkstg.wpenginepowered.com' || 'https://localhost:8000';
const DEALERS_API_BASE_URL = process.env.REACT_APP_DEALERS_API_BASE_URL || 'https://dev.admin.kubotacore.com';

// Endpoint definitions organized by functionality
const endpointPaths = {
  // Product-related endpoints
  products: {
    getProducts: "/Products/",
    getProductDetails: "/live/Tractor/",
    getProductEquipment: "/live/StandardEquipment/",
    getIncentives: "/Incentives"
  },

  // Land Pride configuration endpoints
  landPride: {
    startLandPride: "/lpconfig/start/",
    continueLandPride: "/lpconfig/continue",
    cancelLandPride: "/lpconfig/cancel"
  },

  // Dealer and location endpoints
  // Note: requires headers:
  //   - 'Accept': 'application/json'
  //   - 'api-key': process.env.REACT_APP_DEALERS_API_KEY
  dealers: {
    getLocationsByAddress: "/api/v1/dealers/zipcode",
    getLocationsByDealerGroup: "/api/v1/dealers",
    getDealersByEquipment: "/api/v1/dealers/zipcode/base-model"
  },

  // Quote and save endpoints
  quotes: {
    IKQSaveData: "/quote/savedata",
    IKQSavePDF: "/quote/savepdf",
    IKQGeneratePDF: "/quote/pdf/"
  },

  // Authentication endpoints : GraphQL API is used for authentication
  /*
  auth: {
    checkLoginStatus: "/account/bmkchecklogin",
    login: "/token",
    logout: "/token/revoke",
    sendCode: "/signup/send-code",
    verifyCode: "/signup/verify-code",
    signUp: "/signup/complete",
    resetPassword: "/account/recoverpassword",
    forgotPassword: "/forgot-password",
    updateProfile: "/me/update",
    getProfile: "/me",
    changePassword: "/me/change-password",
  },
  */

  // Build management endpoints (WordPress API) : GraphQL API is used for build management
  /*
  builds: {
    saveBuild: "/bmksavebuild",
    getSavedBuild: "/bmkloadbuild",
    getAllSavedBuilds: "/bmkloadbuilds"
  },
  */

  // Utility endpoints
  utils: {
    isDraftUser: "/inventory/checkbmkdraft",
    logError: "/inventory/bmkerror"
  },

  // Static file endpoints
  static: {
    config: "/config.json",
    banners: "/banners.json"
  }
};

// API source mapping - defines which base URL each endpoint group uses
const apiSourceMapping = {
  products: API_BASE_URL,
  landPride: API_BASE_URL,
  dealers: DEALERS_API_BASE_URL,
  quotes: API_BASE_URL,
  //auth: WP_API_BASE_URL,
  //builds: WP_API_BASE_URL,
  utils: API_BASE_URL,
  static: window.location.origin
};

/**
 * Builds the complete service object with full URLs
 * @returns {Object} Service object with endpoint names as keys and full URLs as values
 */
const buildServiceUrls = () => {
  const service = {};
  
  Object.entries(endpointPaths).forEach(([category, endpoints]) => {
    const baseUrl = apiSourceMapping[category];
    
    Object.entries(endpoints).forEach(([endpointName, path]) => {
      service[endpointName] = `${baseUrl}${path}`;
    });
  });
  
  return service;
};

// Export the service object
const bmkservice = buildServiceUrls();

export default bmkservice;
